import { __assign, __awaiter, __generator } from "tslib";
import { AfterViewInit, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BehaviorSubject, combineLatest, Subscription } from 'rxjs';
import * as fromAuth from '../auth/reducers';
import { CognitoWrapperService } from '../core/services/congito.wrapper.service';
import { ScriptInjectorService } from '../core/services/script-injector.service';
import { environment } from '../../environments/environment';
import { AdminPage } from '../react/pages/admin/AdminPage';
import * as fromSettings from '../settings/reducers';
var containerElementName = 'portalAdminReactContainer';
var AdminComponent = /** @class */ (function () {
    function AdminComponent(_store, _cognito, _scriptInjector) {
        this._store = _store;
        this._cognito = _cognito;
        this._scriptInjector = _scriptInjector;
        this._formDesignerLoaded$ = new BehaviorSubject(false);
        this._formDesignerScriptRequested = false;
        this._subscriptions = new Subscription();
    }
    AdminComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._subscriptions.add(this._store
            .pipe(select(fromAuth.getFormDefinitionsEnabled))
            .subscribe(function (enabled) {
            if (enabled && !_this._formDesignerScriptRequested) {
                _this._formDesignerScriptRequested = true;
                _this._scriptInjector
                    .loadScript('salve-clinic-form-designer', environment.formDesignerComponentUrl)
                    .then(function () { return _this._formDesignerLoaded$.next(true); })
                    .catch(function () { return _this._formDesignerLoaded$.next(false); });
            }
        }));
        this._subscriptions.add(combineLatest([
            this._store.pipe(select(fromAuth.getClinicId)),
            this._store.pipe(select(fromAuth.getClinicOptions)),
            this._store.pipe(select(fromAuth.getUser)),
            this._store.pipe(select(fromSettings.getCurrentLanguage)),
            this._store.pipe(select(fromSettings.getLanguageTranslations)),
            this._formDesignerLoaded$
        ]).subscribe(function (_a) {
            var clinicToken = _a[0], clinicOptions = _a[1], user = _a[2], language = _a[3], translations = _a[4], formDesignerLoaded = _a[5];
            _this._props = {
                clinicToken: clinicToken,
                features: clinicOptions,
                language: language,
                translations: translations,
                user: user,
                formDesignerLoaded: formDesignerLoaded
            };
            _this.render();
        }));
    };
    AdminComponent.prototype.ngAfterViewInit = function () {
        this.render();
    };
    AdminComponent.prototype.ngOnDestroy = function () {
        ReactDOM.unmountComponentAtNode(this.containerRef.nativeElement);
        this._subscriptions.unsubscribe();
    };
    AdminComponent.prototype.render = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                ReactDOM.render(React.createElement(AdminPage, __assign(__assign({}, this._props), { authService: this._cognito, dispatch: this._store.dispatch.bind(this._store) })), this.containerRef.nativeElement);
                return [2 /*return*/];
            });
        });
    };
    return AdminComponent;
}());
export { AdminComponent };
